/** "Delete my account" (plan 16), through the deleteMyAccount Cloud Function. */
import { useCallback, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { signOut } from 'firebase/auth';
import { auth, functions } from '../config/firebase';

export function useDeleteMyAccount() {
  const [deleting, setDeleting] = useState(false);

  /** Deletes the account on the server. Throws when it could not be deleted. */
  const deleteMyAccount = useCallback(async () => {
    setDeleting(true);
    try {
      await httpsCallable<Record<string, never>, { ok: boolean; listings: number }>(functions, 'deleteMyAccount')({});
    } finally {
      setDeleting(false);
    }
  }, []);

  /** Afterwards: sign out on this device (call once the page has left the signed-in area). */
  const finishSignOut = useCallback(() => signOut(auth).catch(() => undefined), []);

  return { deleting, deleteMyAccount, finishSignOut };
}
